import { Box, Grid, Heading, Image, Text, Stack, Flex } from "@chakra-ui/react";
import React from "react";

// Image imports
import bgImage from "../../../assets/home/servicebg.png"; // Fort image (left side)
import paaji from "../../../assets/home/paji2.png"; // Paaji beside heading
import flower from "../../../assets/home/flowerr.png"; // Behind heading
import card1 from "../../../assets/home/sc1.png";
import card2 from "../../../assets/home/sc2.png";
import card3 from "../../../assets/home/sc3.png";
import card4 from "../../../assets/home/sc4.png";
import card5 from "../../../assets/home/sc5.png";
import card6 from "../../../assets/home/sc6.png";
import FlowerImage from "component/FlowerImage";
import red from "../../../assets/flower/redd.png";

const Services = () => {
  const cards = [card1, card2, card3, card4, card5, card6];

  return (
    <Box bg="#F9E8D4" py={{ base: 24, md: 0 }} px={{ base: 0, md: 0 }}>
      <FlowerImage
        src={red}
        top={{ base: "69%", md: "65%" }}
        right={{ base: "48%", md: "20%" }}
        width={{ base: "15px", md: "15px" }}
      />
      <Flex
        direction={{ base: "column", md: "row" }}
        align="stretch"
        justify="center"
      >
        {/* Left Fort Image */}
        <Box
          w={{ base: "100%", md: "81%" }}
          position={{ base: "absolute", md: "relative" }}
          h={{ base: "600px", md: "600px" }}
          backgroundImage={`url(${bgImage})`}
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundRepeat="no-repeat"
          mb={{ base: 8, md: 0 }}
          display={{ base: "block", md: "flex" }}
          justifyContent={"center"}
          alignItems={"center"}
          flexDirection={"column"}
        >
          {/* Flower behind heading */}

          {/* Heading */}
          <Stack
            direction="row"
            align="center"
            justify={{ base: "center", md: "flex-start" }}
            spacing={4}
            my={{ base: 6, md: 10 }}
            textAlign={{ base: "center", md: "left" }}
            position="relative"
          >
            <Image
              src={flower}
              alt="Flower"
              position="absolute"
              top="0"
              left={{ base: "50%", md: "10%" }}
              transform="translate(-50%, -30%)"
              boxSize={{ base: "100px", md: "220px" }}
              opacity={1}
              zIndex={10}
             
            />
            <Box>
              <Heading fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold" className="fade-in-up">
                We Are{" "}
                <Text as="span" color="#BFA585" className="fade-in-up">
                  Best
                </Text>
                , <br />
                Our Numbers Speak{" "}
                <Text as="span" fontStyle="italic" color="gray.600">
                  Louder!
                </Text>
              </Heading>
            </Box>
            <Image
              src={paaji}
              alt="Paaji"
              maxW={{ base: "60px", md: "90px" }}
              mt={{ base: 2, md: 0 }}
              display={{ base: "none", md: "block" }}
              data-animated = 'true'
            />
          </Stack>
        </Box>

        {/* Right Content */}
        <Box
          margin={"auto"}
          w={{ base: "100%", md: "55%" }}
          position="relative"
          zIndex={1}
          px={{ base: 2, md: 6 }}
        >
          {/* Cards Grid */}
          <Grid
            templateColumns={{ base: "repeat(2, 1fr)", sm: "repeat(3, 1fr)" }}
            gap={{ base: 4, md: 6 }}
            justifyItems="center"
            zIndex={1}
          >
            {cards.map((card, idx) => (
              <Image
                          className="fade-in-up"
                key={idx}
                src={card}
                pt={{ base: "0", md: idx === 1 || idx === 4 ? 6 : 0 }} // Applies padding only to 1st and 4th card
                alt={`Card ${idx + 1}`}
                maxW={{ base: "100px", sm: "120px", md: "150px" }}
                w="100%"
              />
            ))}
          </Grid>
        </Box>
      </Flex>
    </Box>
  );
};

export default Services;
